export default __webpack_public_path__ + "static/media/logo_frecciargento.5b76d6e5.svg";